module.exports = __webpack_public_path__ + "img/template-mobile-blank.9186f6ef.svg";